import React from 'react'
import './ProgressbarStyle.css';

function Progressbar({count}) {

    const numbers = [1,2,3,4,5];

    return (
        <div className='ProgressBarwrapper'>
            <div className='ProgressBarline'>
                {numbers.map((item) => (
                    <span className={`progressCountgreen ${item <= count && 'active'}`}></span>
                ))}
                
                <div className='dotesprogress'></div>
            </div>
            <div className="numberwrapperproress">
                <div className='numberPoints'>0</div>
                <div className='numberPoints'>1</div>
                <div className='numberPoints'>2</div>
                <div className='numberPoints'>3</div>
                <div className='numberPoints'>4</div>
                <div className='numberPoints'>5</div>
            </div>
        </div>
    )
}

export default Progressbar